import React, { PureComponent, Fragment } from 'react';
import { Container, Col, Row } from 'bootstrap-4-react';    
// import assetImage from './../../../assets/img/2020_Properties_Assets-02.jpg';
import axios from 'axios';
import * as apiUrl from '../../../apiUrl';

// import { Link } from 'react-router-dom';
import { useParams } from "react-router-dom";


function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class PropertiesDescription extends PureComponent {


    constructor(props) {
        super(props);
        this.state = {

            selectedFiles: undefined,
            currentFile: undefined,
            section_title: "",
            section_description: "",

            errors: {},
            imageURL: "",
            data: {

            },

            formValues1: [{ pipt_id: "", slider_image: [], imageURL: "", section_title: "", section_description: "" }],
            errors1: [{ pipt_id: "", slider_image: "", section_title: "", section_description: "" }],


            section_title2: "",
            section_description2: "",
            brochure_text: "",
            factsheet_text: "",
            background_image: "",
            brochure_pdf: "",
            factsheet_pdf: "",
            ImageURL1: "",
            ImageURL2: "",
            ImageURL3: "",
            ImageURL4: "",
            section_title3: "",
           


          



            

        };

        

    




    }

    componentDidUpdate(prevProps) {


        if ( this.props.params.id !== prevProps.params.id ) {

        const { id } = this.props.params;

        let self = this;

        

        axios.post(apiUrl.apiUrl + '/propertiesinnerpage/edit_propertiesinner_post/' + id)
            .then(res => {



                self.setState({
             
                    post_id: res.data[0].id,
                    section_title2: res.data[0].section_title2,
                    section_description2: res.data[0].section_description2,
                    section_title3: res.data[0].section_title3,
                    section_description3: res.data[0].section_description3,
                    section_title4: res.data[0].section_title4,
                    section_description4: res.data[0].section_description4,
                    section_title5: res.data[0].section_title5,
                    section_description5: res.data[0].section_description5,
                    brochure_text: res.data[0].brochure_text,
                    brochure_pdf: apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" +res.data[0].brochure_pdf,
                    ImageURL4: res.data[0].brochure_pdf,

                    ImageURL3: res.data[0].factsheet_pdf,
                    factsheet_pdf: apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" +res.data[0].factsheet_pdf,

                    factsheet_text: res.data[0].factsheet_text,
                    section_title6: res.data[0].section_title6,
                    section_description6: res.data[0].section_description6,
                    section_title7: res.data[0].section_title7,
                    section_description7: res.data[0].section_description7,
                    section_title8: res.data[0].section_title8,


                    

                    ImageURL2: apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" + res.data[0].background_image2,


                });

            });

        }


    }

    async componentDidMount() {

        const { id } = this.props.params;

        let self = this;

        

        axios.post(apiUrl.apiUrl + '/propertiesinnerpage/edit_propertiesinner_post/' + id)
            .then(res => {



                self.setState({
             
                    post_id: res.data[0].id,
                    section_title2: res.data[0].section_title2,
                    section_description2: res.data[0].section_description2,
                    section_title3: res.data[0].section_title3,
                    section_description3: res.data[0].section_description3,
                    section_title4: res.data[0].section_title4,
                    section_description4: res.data[0].section_description4,
                    section_title5: res.data[0].section_title5,
                    section_description5: res.data[0].section_description5,
                    brochure_text: res.data[0].brochure_text,
                    brochure_pdf: apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" +res.data[0].brochure_pdf,
                    ImageURL4: res.data[0].brochure_pdf,

                    ImageURL3: res.data[0].factsheet_pdf,
                    factsheet_pdf: apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" +res.data[0].factsheet_pdf,

                    factsheet_text: res.data[0].factsheet_text,
                    section_title6: res.data[0].section_title6,
                    section_description6: res.data[0].section_description6,
                    section_title7: res.data[0].section_title7,
                    section_description7: res.data[0].section_description7,
                    section_title8: res.data[0].section_title8,


                    

                    ImageURL2: apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" + res.data[0].background_image2,


                });

            });
            

        }


    render() { 


        let sd = this.state.section_description2.split("\n");

        return (
          <Fragment>  
              <Container fluid className="secSpacing"> 
                <Row className="m-0">
                <Col lg={1}></Col>
                <Col lg={11} className="p-0"> 
                    <Row className="reverseRow propertiesInnerDes m-0 p-0">   
                        <Col xl={7} lg={6} md={6}>
                            <div className="aboutMissionimage"  data-aos='fade-right'>
                                <img src={this.state.ImageURL2} className="img-fluid" alt="about" />
                            </div>
                        </Col>
                        <Col xl={5} lg={6} md={6}>
                           
                            <div className="homeaboutContentDiv contactDetails">
                                <h2 className="canelaMedium secHeading"  data-aos='fade-left'>{this.state.section_title2}</h2>
                              
                                <p className="paraText"  data-aos='fade-left'>{sd[0]}
</p> 
                                <p className="paraText"  data-aos='fade-left'>{sd[1]}</p>

<Row className="propInnerBtnDiv"  data-aos='fade-left'>
    <Col md={12}>
       <a href={this.state.brochure_pdf} target="_blank" className="darkBlueBtn">
{this.state.brochure_text}</a> &nbsp;&nbsp; 
        <a href={this.state.factsheet_pdf} target="_blank" className="darkBlueBtn">{this.state.factsheet_text}</a> 
    </Col> 
</Row>
                               
                            </div> 
                        </Col>
                        
                    </Row>  
                </Col> 
                <Col lg={1}></Col>
                
                </Row>
            </Container> 

          </Fragment>
        )
      }
}


//export default PropertiesDescription

export default withParams(PropertiesDescription);